



















































































































import { Component, Ref, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { BibliographySearchResultsSimpleTable } from '@/components/organisms/BibliographySearchResultsSimpleTable'
import { BibliographySearchResultsDetailTable } from '@/components/organisms/BibliographySearchResultsDetailTable'
import { BibliographySearchResultsOption } from '@/components/organisms/BibliographySearchResultsOption'
import {
  Alert,
  AlertMessage,
  BibliographySearchResultItem,
  CreateBibliographySearchListRequestItem,
  CreateBibliographySearchDetailListRequestItem,
  ErrorMessage,
  jobApi,
  defaultBibliographySearchNarrowCondition
} from '@/api'
import {
  AlertCodeIL300062,
  AloneSearchType,
  AuthoritySearchType,
  BibliographySearchType,
  CollectionFlag,
  CollectionState,
  CollectionStatus,
  DisplayMethod,
  SearchTarget
} from '@/types'
import {
  alertStore,
  modalBibliographyDetailStore,
  modalBibliographySearchResultStore,
  modalBibliographySearchStore,
  modalErrorStore,
  modalJobListStore,
  systemParameterStore
} from '@/store'
import { AlertFactory } from '@/factory'
import {
  defaultInputBibliographySearchResultsOption,
  InputBibliographySearchResultsOption
} from '@/components/organisms/BibliographySearchResultsOption/BibliographySearchResultsOption.vue'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import { cloneDeep } from 'lodash'
import CODE_KEY from '@/config/code_key'
import { FirstTransitionToBibliographyDetail } from '@/store/BibliographyDetailStore'

@Component({
  components: {
    BibliographySearchResultsOption,
    BibliographySearchResultsSimpleTable,
    BibliographySearchResultsDetailTable,
    ModalFooter
  }
})
export default class ModalBibliographySearchResult extends ModalComponentBaseVue {
  @Ref()
  bibliographySearchResultsOption!: BibliographySearchResultsOption

  tableBodyHeight: number = 0

  displayOption: InputBibliographySearchResultsOption = defaultInputBibliographySearchResultsOption()

  selectedUids: string[] = []

  searching: boolean = false

  scrollTopValue: number = 0

  activeRowIndex: number = 0

  get scrollTop(): number {
    return this.displayMethodIsSimple
      ? this.scrollTopValue
      : (this.scrollTopValue / this.simpleRowHeight) * this.detailRowHeight
  }

  get isOpen() {
    return modalBibliographySearchResultStore.isOpen
  }

  get isSelect(): boolean {
    return modalBibliographySearchResultStore.isSelect
  }

  get page() {
    return modalBibliographySearchStore.page
  }

  get perPage() {
    return modalBibliographySearchStore.perPage
  }

  get total() {
    return modalBibliographySearchStore.total
  }

  get defaultDisplayOption() {
    return modalBibliographySearchStore.displayOption
  }

  get displayItems() {
    return modalBibliographySearchStore.filterItems
  }

  get existsDisplayItems(): boolean {
    return this.displayItems.length > 0
  }

  get searchType(): BibliographySearchType {
    return modalBibliographySearchStore.bibliographySearchType
  }

  get searchTarget(): SearchTarget {
    return modalBibliographySearchStore.searchTarget
  }

  get displayMethodIsSimple() {
    return this.displayOption.displayMethod.input === DisplayMethod.Simple
  }

  get hitCount(): number {
    if (
      this.displayOption.selectedOnly.input === 'on' ||
      this.displayOption.canLendOnly.input === 'on'
    ) {
      return this.displayItems.length
    } else {
      return this.total
    }
  }

  get searchKeyWord() {
    const words: any[] = []
    switch (modalBibliographySearchStore.bibliographySearchType) {
      case BibliographySearchType.Basic:
        const bibliographyItem =
          modalBibliographySearchStore.inputBasicSearchBibliographyItem
        const collectionItem =
          modalBibliographySearchStore.inputBasicSearchCollectionItem

        for (const key in bibliographyItem) {
          if (
            this.isTooliSearch &&
            ![
              'displayMethod',
              'searchMethodAnd',
              'displayBranchCode',
              'title1',
              'title1Not',
              'title2',
              'title2Not',
              'author1',
              'author1Not',
              'author2',
              'author2Not',
              'subject1',
              'subject1Not',
              'subject2',
              'subject2Not',
              'series',
              'seriesNot',
              'publisher',
              'publisherNot',
              'classNo',
              'publishedYearFrom',
              'publishedYearTo',
              'freeWord'
            ].includes(key)
          ) {
            continue
          }

          if (bibliographyItem[key].input) {
            const splitArray = bibliographyItem[key].input.split(',')

            if (splitArray.length > 10) {
              splitArray.splice(10)
            }

            words.push(splitArray.join(','))
          }
        }

        if (!this.isTooliSearch) {
          for (const key in collectionItem) {
            if (key === 'lendTotalFlag' || key === 'lastLendDateFlag') continue

            if (collectionItem[key].input) {
              let splitArray: string[] = collectionItem[key].input.split(',')

              if (splitArray.length > 10) {
                splitArray.splice(10)
              }

              if (
                key === 'collectionStatus' &&
                !collectionItem.collectionStatus.collectionStatusRemove
              ) {
                splitArray = splitArray.filter(
                  value => value !== CollectionStatus.Removed
                )
              }

              words.push(splitArray.join(','))
            }
          }
        }

        return words.join(' ')
      case BibliographySearchType.Alone:
        if (modalBibliographySearchStore.searchBasicCollectionId) {
          return modalBibliographySearchStore.inputBasicSearchBibliographyItem
            .title1.input
        }

        const aloneItem = modalBibliographySearchStore.inputAloneSearchItem

        switch (aloneItem.searchType) {
          case AloneSearchType.NewPublicationInformationDate:
            return aloneItem.newPublicationInformationDate.input
          case AloneSearchType.NewPublicationInformationVolume:
            return aloneItem.newPublicationInformationVolume.input
          case AloneSearchType.CollectionNo:
            return aloneItem.collectionNo.input
          case AloneSearchType.OrderId:
            return aloneItem.orderId.input
          case AloneSearchType.Bibliography:
            return (
              aloneItem.bibliographyId.bibliographyClass +
              ' ' +
              aloneItem.bibliographyId.input
            )
          case AloneSearchType.Isbn:
            return aloneItem.isbn.input
          case AloneSearchType.ProductNumber:
            return aloneItem.productNumber.input
          case AloneSearchType.MagazineCode:
            return aloneItem.magazineCode.input
          case AloneSearchType.Marc:
            return aloneItem.marcType.input + ' ' + aloneItem.marcNo.input
          default:
            return ''
        }
      case BibliographySearchType.Free:
        const freeResults: any[] = [
          modalBibliographySearchStore.freeWords.freeWords.input
        ]
        const andKey: any = modalBibliographySearchStore.freeWords.andKey

        for (const key in andKey) {
          if (key === 'lendTotalFlag' || key === 'lastLendDateFlag') {
            continue
          }

          if (andKey[key].input) {
            let splitArray: string[] = andKey[key].input.split(',')

            if (splitArray.length > 10) {
              splitArray.splice(10)
            }

            if (
              key === 'collectionStatus' &&
              !andKey.collectionStatus.collectionStatusRemove
            ) {
              splitArray = splitArray.filter(
                value => value !== CollectionStatus.Removed
              )
            }

            freeResults.push(splitArray.join(','))
          }
        }

        return freeResults.join(' ')
      case BibliographySearchType.Authority:
        const authorityItem: any =
          modalBibliographySearchStore.inputAuthoritySearchItem

        switch (modalBibliographySearchStore.authoritySearchType) {
          case AuthoritySearchType.Author:
            return authorityItem.author.input
          case AuthoritySearchType.ContentAuthor:
            return authorityItem.contentAuthor.input
          case AuthoritySearchType.Subject:
            return authorityItem.subject.input
          case AuthoritySearchType.CompleteWorks:
            return authorityItem.series.input
          case AuthoritySearchType.Series:
            return authorityItem.completeWorks.input
          case AuthoritySearchType.Publisher:
            return authorityItem.publisher.input
          default:
            return ''
        }
      case BibliographySearchType.Content:
        if (!this.isTooliSearch) {
          return ''
        }

        const contentItem: any =
          modalBibliographySearchStore.inputContentSearchItem

        for (const key in contentItem) {
          if (key === 'holdingBranchCodes') {
            continue
          }

          if (contentItem[key].input) {
            const splitArray = contentItem[key].input.split(',')

            if (splitArray.length > 10) {
              splitArray.splice(10)
            }

            words.push(splitArray.join(','))
          }
        }

        return words.join(' ')
      default:
        return ''
    }
  }

  get showBackResult() {
    return (
      modalBibliographySearchStore.authorityItems.length > 1 ||
      modalBibliographySearchStore.contentItems.length > 0
    )
  }

  get isTooliSearch() {
    return (
      modalBibliographySearchStore.inputSearchOption.searchTarget.input ===
      SearchTarget.Tooli
    )
  }

  get simpleRowHeight(): number {
    return 34
  }

  get detailRowHeight(): number {
    return 57
  }

  get isAllSelect(): boolean {
    return modalBibliographySearchStore.isAllSelect
  }

  set isAllSelect(value: boolean) {
    modalBibliographySearchStore.setIsAllSelect(value)
  }

  get isGotAllSearchResults(): boolean {
    return this.total === modalBibliographySearchStore.items.length
  }

  get isFetchingBibliographySearchList(): boolean {
    return modalBibliographySearchStore.isFetchingBibliographySearchList
  }

  @Watch('isFetchingBibliographySearchList', { immediate: true })
  onChangeIsFetchingBibliographySearchList(newVal: boolean): void {
    if (newVal) {
      this.$eventBus.emit(NAV_LOADING_START)
      return
    }

    this.$eventBus.emit(NAV_LOADING_END)
  }

  @Watch('displayMethodIsSimple')
  toggleDisplayTable() {
    this.calculateTableHeight()
    this.$nextTick(() => {
      setTimeout(this.setScroll)
    })
  }

  @Watch('selectedUids')
  onChangeSelectedUids(newVal: string[]): void {
    modalBibliographySearchStore.setSelectedUids([...newVal])
  }

  @Watch('defaultDisplayOption', { immediate: true, deep: true })
  onChangeDefaultDisplayOption() {
    this.displayOption = cloneDeep(this.defaultDisplayOption)
  }

  @Watch('isOpen')
  initialize() {
    systemParameterStore.fetchAllAndMergeByCodeKeys([
      CODE_KEY.DETAIL_LIST_DISPLAY_SETTING_3.KEY // タイトル列のヘッダー表示設定に使用
    ])

    if (this.isOpen) {
      this.$nextTick(() => {
        window.addEventListener('resize', this.calculateTableHeight)
        this.calculateTableHeight()
      })
      setTimeout(() => {
        this.selectedUids = [...modalBibliographySearchStore.selectedUids]
        this.scrollTopValue = modalBibliographySearchStore.scrollTopValue
        this.activeRowIndex = modalBibliographySearchStore.activeRowIndex
        this.displayOption.displayMethod.input =
          modalBibliographySearchStore.displayMethod
        this.setScroll()
      })
      return
    }

    modalBibliographySearchStore.setSelectedUids([...this.selectedUids])
    modalBibliographySearchStore.setScrollTopValue(this.scrollTopValue)
    modalBibliographySearchStore.setActiveRowIndex(this.activeRowIndex)
    modalBibliographySearchStore.setSearchDisplayMethod(
      this.displayOption.displayMethod.input
    )
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  // 本ページにおけるローディング制御は下記二つのメソッドを利用する事
  // 複数のAPIを処理する事が多い為、イベントバスによる制御処理は慎重に行う必要がある
  navLoadingStart(): void {
    if (!this.isFetchingBibliographySearchList) {
      this.$eventBus.emit(NAV_LOADING_START)
    }
  }

  navLoadingEnd(): void {
    if (!this.isFetchingBibliographySearchList) {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  close() {
    modalBibliographySearchResultStore.close()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-bibliography-search-result')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  calculateTableHeight() {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  async onRequestNextPage() {
    this.navLoadingStart()
    this.searching = true

    modalBibliographySearchStore.addPage()
    modalBibliographySearchStore.setSaveHistory(false)

    try {
      switch (modalBibliographySearchStore.bibliographySearchType) {
        case BibliographySearchType.Basic:
          await modalBibliographySearchStore.search()
          break
        case BibliographySearchType.Free:
          await modalBibliographySearchStore.freeSearch()
          break
        case BibliographySearchType.Authority:
          await modalBibliographySearchStore.authorityIdSearch()
          break
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.navLoadingEnd()
    }
  }

  async onChangeAllSelect(value: boolean) {
    this.isAllSelect = value

    if (!this.isAllSelect) {
      this.selectedUids = []
      return
    }

    if (this.isGotAllSearchResults) {
      this.selectedUids = this.displayItems.map(item => item.uid)
      return
    }

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await modalBibliographySearchStore.searchAll()
      this.selectedUids = this.displayItems.map(item => item.uid)
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  onClickSelectedOnly() {
    if (this.displayOption.selectedOnly.input) {
      this.displayOption.selectedOnly.input = ''
    } else {
      this.displayOption.selectedOnly.input = 'on'
    }

    modalBibliographySearchStore.setDisplayOption(this.displayOption)
  }

  async onClickCanLendOnly() {
    if (this.displayOption.canLendOnly.input) {
      this.displayOption.canLendOnly.input = ''
      modalBibliographySearchStore.setDisplayOption(this.displayOption)
      return
    } else if (
      !this.displayOption.canLendOnly.input &&
      this.isGotAllSearchResults
    ) {
      this.displayOption.canLendOnly.input = 'on'
      modalBibliographySearchStore.setDisplayOption(this.displayOption)
      return
    }

    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await modalBibliographySearchStore.searchAll()

      this.displayOption.canLendOnly.input = 'on'
      modalBibliographySearchStore.setDisplayOption(this.displayOption)
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  setErrorMessage(alerts: Alert[], obj: any): void {
    alerts.forEach(alert => {
      if (alert.attribute === '') return false
      const key: keyof typeof obj = alert.attribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      ) as typeof obj
      const subKey: string = alert.subAttribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      )
      const splitKeys: string[] = (key as string).split('.')

      if (
        obj[key] !== undefined &&
        subKey !== '' &&
        Array.isArray(obj[key]) &&
        Object.prototype.toString
          .call(obj[key][alert.index][subKey])
          .slice(8, -1) === 'Object' &&
        (obj[key][alert.index][subKey] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key][alert.index][subKey] as any).errorMessage = alert.message
        return
      }

      if (
        obj[key] !== undefined &&
        Object.prototype.toString.call(obj[key]).slice(8, -1) === 'Object' &&
        (obj[key] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key] as any).errorMessage = alert.message
        return
      }

      if (splitKeys.length > 1 && subKey === '') {
        if (
          obj[splitKeys[0]][splitKeys[1]] !== undefined &&
          Object.prototype.toString
            .call(obj[splitKeys[0]][splitKeys[1]])
            .slice(8, -1) === 'Object' &&
          (obj[splitKeys[0]][splitKeys[1]] as any).hasOwnProperty(
            'errorMessage'
          )
        ) {
          ;(obj[splitKeys[0]][splitKeys[1]] as any).errorMessage = alert.message
        }
      }
    })
  }

  async onClickReload() {
    try {
      modalBibliographySearchStore.setDisplayOption(this.displayOption)
      modalBibliographySearchStore.resetListDetail()
      await modalBibliographySearchStore.fetchSearchListDetail(true)
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts, this.displayOption)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async narrowSearch() {
    if (document.activeElement !== null) {
      ;(document.activeElement as any).blur()
    }

    this.$eventBus.emit(PAGE_LOADING_START)
    this.searching = true

    try {
      await modalBibliographySearchStore.narrowSearch({
        narrowKeyword: this.displayOption.narrowKeyword.input,
        narrowTarget: this.displayOption.narrowTarget.input
      })
      this.displayOption.isNarrowSearched = true
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts, {
          narrow: {
            title: this.displayOption.narrowKeyword,
            author: this.displayOption.narrowKeyword,
            publisher: this.displayOption.narrowKeyword,
            materialFormat: this.displayOption.narrowKeyword,
            freeWord: this.displayOption.narrowKeyword
          }
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          onOkClick: this.bibliographySearchResultsOption.focusNarrowKeyword
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open({
          onOkClick: this.bibliographySearchResultsOption.focusNarrowKeyword
        })
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  // 再検索をしているだけなので、ボタン「再取得」処理を実装する時に流用可能
  async clearNarrow() {
    this.$eventBus.emit(PAGE_LOADING_START)

    this.searching = true

    try {
      modalBibliographySearchStore.setNarrowedCondition(
        defaultBibliographySearchNarrowCondition()
      )
      await modalBibliographySearchStore.reconfigureSearchResult()

      const defaultItem: InputBibliographySearchResultsOption = defaultInputBibliographySearchResultsOption()
      this.displayOption.narrowKeyword.input = defaultItem.narrowKeyword.input
      this.displayOption.narrowTarget.input = defaultItem.narrowTarget.input
      this.displayOption.isNarrowSearched = defaultItem.isNarrowSearched
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.searching = false
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  onClickTitle(item: BibliographySearchResultItem) {
    this.setActiveRow(
      this.displayItems.findIndex(value => value.uid === item.uid)
    )

    modalBibliographyDetailStore.setFirstTransitionSource(
      FirstTransitionToBibliographyDetail.SearchResult
    )
    modalBibliographySearchResultStore.title({
      prefix: item.prefix,
      id: !this.isTooliSearch ? item.bibliographyId : undefined,
      marcNo: this.isTooliSearch ? item.marcNo : undefined
    })
  }

  onClickSelect() {
    if (this.selectedUids.length === 0) {
      const alert: Alert = AlertFactory.create(AlertCodeIL300062, '1件')
      alertStore.setItem(alert)
      this.$modalAlert.open()
      return
    }

    // TODO 書誌統合時、集合書誌を取得できなくなるのでコメントアウト
    // TODO 予約処理作成時に見直しを行いたい
    // TODO 使用するidの変更に伴い、コメントアウトしているコードでは処理をしないかもしれないので注意
    // if (this.selectedUids.some(id => id[0] === Prefix.Set)) {
    //   const alert: Alert = AlertFactory.create('IL300063')
    //   alertStore.setItem(alert)
    //   this.$modalAlert.open()
    //   return
    // }
    modalBibliographySearchResultStore.select(
      this.displayItems
        .filter(item => this.selectedUids.includes(item.uid))
        .map(item => {
          return {
            prefix: item.prefix,
            id: item.bibliographyId,
            marcNo: item.marcNo
          }
        })
    )
  }

  setScrollTop(value: number): void {
    this.scrollTopValue = this.displayMethodIsSimple
      ? value
      : (value / this.detailRowHeight) * this.simpleRowHeight
  }

  setScroll(): void {
    setTimeout(() => {
      const tableScroller: HTMLCollection | null = document.getElementsByClassName(
        'search-result-scroller'
      ) as HTMLCollectionOf<HTMLElement>

      // 小数のままだと切り替える度に少しだけ値が変わってしまっていたので四捨五入で対応
      tableScroller[0].scrollTo(0, Math.round(this.scrollTop))
    })
  }

  setActiveRow(index: number): void {
    this.activeRowIndex = index
  }

  onClickBackCondition() {
    modalBibliographySearchResultStore.backCondition()
  }

  onClickBackResult() {
    modalBibliographySearchResultStore.backResult()
  }

  async downloadList(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    const createBibliographySearchList = async () => {
      try {
        let bibliographies: BibliographySearchResultItem[] =
          modalBibliographySearchStore.items

        if (this.displayOption.selectedOnly.input) {
          bibliographies = modalBibliographySearchStore.items.filter(item => {
            return this.selectedUids.includes(item.uid)
          })
        }

        const jobId = await jobApi.createBibliographySearchList({
          bibliographies: bibliographies.map(item => {
            return {
              prefix: item.prefix,
              bibliographyId: item.bibliographyId,
              shelfTypeName: item.shelfType,
              callNo: item.callNo,
              collectionState: this.collectionState(item),
              collectionNo: item.collectionNo,
              handlingTypeName: item.handlingType,
              collectionStatusName: item.collectionStatus,
              shelfCount: item.shelfCount,
              holdingCount: item.holdingCount,
              orderCount: item.orderCount,
              reserveCount: item.reserveCount
            } as CreateBibliographySearchListRequestItem
          })
        })

        await modalJobListStore.newJobId(jobId)
      } catch (error) {
        if (error instanceof AlertMessage) {
          alertStore.setItems(error.alerts)
          this.$modalAlert.open()
        } else if (error instanceof ErrorMessage) {
          modalErrorStore.init(error)
          this.$modalError.open()
        } else {
          console.error(error)
        }
      } finally {
        this.$eventBus.emit(PAGE_LOADING_END)
      }
    }

    if (!this.isGotAllSearchResults) {
      await modalBibliographySearchStore.searchAll()
    } else if (this.isFetchingBibliographySearchList) {
      const unwatch = this.$watch('isFetchingBibliographySearchList', () => {
        createBibliographySearchList().finally(unwatch)
      })
      return
    }

    createBibliographySearchList()
  }

  async downloadDetailList(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    const createBibliographySearchList = async () => {
      try {
        let bibliographies: BibliographySearchResultItem[] =
          modalBibliographySearchStore.items

        if (this.displayOption.selectedOnly.input) {
          bibliographies = modalBibliographySearchStore.items.filter(item => {
            return this.selectedUids.includes(item.uid)
          })
        }

        const jobId = await jobApi.createBibliographySearchDetailList({
          bibliographies: bibliographies.map(item => {
            return {
              prefix: item.prefix,
              bibliographyId: item.bibliographyId,
              shelfTypeName: item.shelfType,
              callNo: item.callNo,
              collectionState: this.collectionState(item),
              collectionNo: item.collectionNo,
              handlingTypeName: item.handlingType,
              collectionStatusName: item.collectionStatus,
              shelfCount: item.shelfCount,
              holdingCount: item.holdingCount,
              orderCount: item.orderCount,
              reserveCount: item.reserveCount
            } as CreateBibliographySearchDetailListRequestItem
          })
        })

        await modalJobListStore.newJobId(jobId)
      } catch (error) {
        if (error instanceof AlertMessage) {
          alertStore.setItems(error.alerts)
          this.$modalAlert.open()
        } else if (error instanceof ErrorMessage) {
          modalErrorStore.init(error)
          this.$modalError.open()
        } else {
          console.error(error)
        }
      } finally {
        this.$eventBus.emit(PAGE_LOADING_END)
      }
    }

    if (!this.isGotAllSearchResults) {
      await modalBibliographySearchStore.searchAll()
    } else if (this.isFetchingBibliographySearchList) {
      const unwatch = this.$watch('isFetchingBibliographySearchList', () => {
        createBibliographySearchList().finally(unwatch)
      })
      return
    }

    createBibliographySearchList()
  }

  collectionState(item: BibliographySearchResultItem): string {
    if (item.holdingCount === null) {
      return CollectionState.NotEntry
    }

    switch (item.collectionFlag) {
      case CollectionFlag.NotCollection:
        return CollectionState.NotHolding
      case CollectionFlag.Collection:
        if (!item.canLendHandlingType) {
          return CollectionState.CanNotLend
        }
        if (item.collectionStatus === '書架') {
          return CollectionState.CanLend
        } else if (item.collectionStatus === '貸出中') {
          return CollectionState.Lending
        } else {
          return CollectionState.CanNotLend
        }
      case CollectionFlag.OrderOnly:
        return CollectionState.HasOrder
      case CollectionFlag.SelectionOnly:
        return CollectionState.HasSelection
    }

    return ''
  }
}
